import AssessmentStorageClient from './AssessmentStorageClient';

class OLSOfflineStorage extends AssessmentStorageClient {
    FORMS_KEY = 'ols_forms';

    CUTSCORES_KEY = 'ols_cutscores';

    OFFLINE_RESULTS_KEY = 'ols_results';

    FORMS_BLACKLIST_DETAILS_KEYS = ['sentences'];

    // eslint-disable-next-line class-methods-use-this
    getStudentResultsKey(studentId) {
        return `ols_student_${studentId}_results_compressed`;
    }
}

export default OLSOfflineStorage;
